module.exports = __webpack_public_path__ + "static/media/pLogo.d6175b6e.png";